import { mdiTrashCanOutline, mdiWaterPump } from '@mdi/js'
import Icon from '@mdi/react'
import { Box } from '@mui/material'
import { FC } from 'react'

import type { SpecialEventType } from '../../data'
import { EVENT_DONE_COLOR } from '../../theme'

const ICONS: Record<SpecialEventType, string> = {
  MARPOL: mdiTrashCanOutline,
  BOMBEO: mdiWaterPump,
}

const DONE = EVENT_DONE_COLOR
const TODO = '#6b7280'

export interface SpecialEventIconProps {
  type: SpecialEventType
  /** Done = the scale holds this event (green); otherwise a grey outline to fill in. */
  done: boolean
  size?: number
}

/** MARPOL (bin) or BOMBEO (pump) in a circle, as bombeo-app draws it. */
export const SpecialEventIcon: FC<SpecialEventIconProps> = ({ type, done, size = 24 }) => (
  <Box
    data-testid={`special-event-icon-${type}${done ? '-done' : ''}`}
    aria-label={type}
    role="img"
    sx={{
      width: size + 8,
      height: size + 8,
      borderRadius: '50%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      bgcolor: done ? DONE : 'transparent',
      border: done ? 'none' : `1px solid ${TODO}`,
      boxShadow: done ? 1 : 'none',
    }}
  >
    <Icon path={ICONS[type]} size={`${String(size - 6)}px`} color={done ? '#ffffff' : TODO} />
  </Box>
)
